import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Button, Message } from 'semantic-ui-react';
import {
  showDeleteHardwareConfirmation,
  deleteHardwareProduct,
} from 'state/hardwareCatalogue/actions';

export class DeleteHardwareConfirmationModal extends React.Component {
  constructor(props) {
    super(props);
    this.onClose = this.onClose.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
  }

  onClose() {
    const { dispatch } = this.props;
    dispatch(showDeleteHardwareConfirmation(false, null));
  }

  onConfirm() {
    const { dispatch, productToDelete } = this.props;
    if (!productToDelete || !productToDelete.id) {
      return;
    }
    dispatch(deleteHardwareProduct(productToDelete.id));
  }

  render() {
    const { isOpen, isLoading } = this.props;

    return (
      <Modal open={isOpen} onClose={this.onClose} size="tiny">
        <Modal.Header>Delete Hardware</Modal.Header>
        <Modal.Content>
          <Message warning>
            <Message.Header>
              Are you sure you want to delete this hardware item?
            </Message.Header>
            <p>It will no longer be available for quotation creation.</p>
          </Message>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.onClose}>Cancel</Button>
          <Button negative onClick={this.onConfirm} loading={isLoading}>
            Delete
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

DeleteHardwareConfirmationModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  productToDelete: PropTypes.object,
};

DeleteHardwareConfirmationModal.defaultProps = {
  isOpen: false,
  isLoading: false,
  productToDelete: null,
};

const mapStateToProps = state => ({
  isOpen: state.hardwareCatalogue.deleteConfirmation.isOpen,
  isLoading: state.hardwareCatalogue.deleteConfirmation.isLoading,
  productToDelete: state.hardwareCatalogue.deleteConfirmation.productToDelete,
});

export default connect(mapStateToProps)(DeleteHardwareConfirmationModal);
